import { createSlice } from "@reduxjs/toolkit";
import { SignUp } from "../../reduxApi/SingIn&SingUp/SingUpApi";

const SignUpSlice = createSlice({
  name: "SignUp",
  initialState: {
    status: "idle",
    SignUp: {},
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SignUp.pending, (state) => {
        state.status = "pending";
      })
      .addCase(SignUp.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.SignUp = action.payload.data;
        console.log("Sing Up Response:", state.SignUp);
      })
      .addCase(SignUp.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to fetch products";
      });
  },
});

export default SignUpSlice.reducer;
